/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

export const REMEMBER_MFA_DEVICE_COOKIE = 'device_id';

export const WORKSPACE_SUPPORT_EMAIL = 'support@blendnotary.com';
export const WORKSPACE_SUPPORT_PHONE = '855-266-4433';
